module.exports = __webpack_public_path__ + "static/media/core_2.058ede2c.png";